"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Location = function Location(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M16.5 10C16.5 7.51869 14.4813 5.5 12 5.5C9.5187 5.5 7.5 7.51869 7.5 10C7.49918 10.7204 7.6724 11.4304 8.00492 12.0694C8.01391 12.1338 8.03537 12.1958 8.06811 12.252L11.5681 18.252C11.6121 18.3275 11.6752 18.3902 11.751 18.4337C11.8268 18.4772 11.9127 18.5002 12.0001 18.5002C12.0875 18.5002 12.1733 18.4772 12.2491 18.4337C12.3249 18.3902 12.388 18.3275 12.432 18.252L15.932 12.252C15.9648 12.1959 15.9862 12.1339 15.9952 12.0695C16.3277 11.4304 16.5009 10.7204 16.5 10Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M12 12.3332C13.2887 12.3332 14.3333 11.2885 14.3333 9.99984C14.3333 8.71117 13.2887 7.6665 12 7.6665C10.7113 7.6665 9.66667 8.71117 9.66667 9.99984C9.66667 11.2885 10.7113 12.3332 12 12.3332Z",
    fill: props.foregroundColor
  }));
};

Location.defaultProps = {
  altText: "Location",
  backgroundColor: "#212121",
  foregroundColor: "#FFFFFF"
};
Location.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Location;
exports.default = _default;